import * as CryptoJS from 'crypto-js';
import { workerData } from 'worker_threads';

// 32-byte 工作金鑰：BaseKey + 當日日期
const today = new Date().toISOString().slice(0, 10);
const baseKey = 'dev-32-byte-idnumber-secret-key-123456';
const workingKey = CryptoJS.SHA256(baseKey + today)
  .toString()
  .slice(0, 32);
const KEY = CryptoJS.enc.Utf8.parse(workingKey);

// 加密，回傳 ivHex:cipherBase64
export function encrypt(plain: string): string {
  const iv = CryptoJS.lib.WordArray.random(16); // 16 Bytes 隨機 IV
  const cipher = CryptoJS.AES.encrypt(plain, KEY, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // iv 是為了解密用
  return iv.toString(CryptoJS.enc.Hex) + ':' + cipher.toString();
}

// 解密
export function decrypt(payload: string): string | null {
  const [ivHex, cipherText] = payload.split(':');
  if (!ivHex || !cipherText) return null;

  try {
    const iv = CryptoJS.enc.Hex.parse(ivHex);
    const bytes = CryptoJS.AES.decrypt(cipherText, KEY, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    // 解析失敗，可能 Key/IV 不符
    return null;
  }
}
